<template>
    <div class="body-panel dataContent">
        <template v-if="reward != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back margin-right-10">
                            <a class="router-link-active" href="" @click.prevent="back">Назад</a>
                        </p>
                        <p class="caption-help margin-right-10" v-if="reward.new">Новое вознаграждение</p>
                        <p class="caption-help" v-if="!reward.new">{{ reward.Name }}</p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex">
                        <button type="button" class="btn btn-primary" @click="saveEntity()" :disabled="savingInProgress">Сохранить</button>
                        <button type="button" class="btn btn-delete" @click="deleteEntity">Удалить</button>
                    </div>

                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <div class="block-in-page">
                    <div class="form-field">
                        <label class="input-text-lbl">
                            Название
                            <span class="required" aria-required="true">*</span>
                        </label>
                        <input name="Name" v-model="reward.Name" v-validate="'required'"
                               :class="['input-text', {'input-error': errors.has('Name')}]" type="text">
                        <span class="field-validation-valid">{{ errors.first('Name') }}</span>
                    </div>
                    <div class="form-field">
                        <label class="input-text-lbl">
                            Описание
                            <span class="required" aria-required="true"></span>
                        </label>
                        <textarea name="Description" rows="10" style="height:150px"
                                  :class="['input-memo', {'input-error': errors.has('Description')}]"
                                  v-model="reward.Description"></textarea>
                        <span class="field-validation-valid">{{ errors.first('Description') }}</span>
                    </div>
                    <div class="form-field">
                        <label class="input-text-lbl">
                            Тип
                            <span class="required" aria-required="true"></span>
                        </label>
                        <drop-down :items="types"
                                   :dataField="'Id'"
                                   :textField="'Name'"
                                   v-model="reward.RewardType"
                                   @change="onRewardTypeChenge"></drop-down>
                        <span class="field-validation-valid">{{ errors.first('RoleId') }}</span>
                    </div>
                    <div class="form-field" v-if="reward.RewardType === 1">
                        <!--<template v-if="reward.OzonCertificate">
        <span style="font-weight: bold;">
            Связано с Озон
        </span>
        <span v-if="reward.HasOrders">
            (отвязать нельзя, есть заказы)
        </span>
        <button v-else type="button" class="btn btn-default" @click="reward.OzonCertificate=null">Отвязать</button>
    </template>-->
                        <template v-if="reward.GifteryId">
                            <span style="font-weight: bold;">
                                Связано с Giftery, id {{reward.GifteryId}}
                            </span>
                            <span v-if="reward.HasOrders">
                                (отвязать нельзя, есть заказы)
                            </span>
                            <button v-else type="button" class="btn btn-default" @click="reward.GifteryId=null">Отвязать</button>
                        </template>
                        <div class="btns flex" v-else>
                            <button type="button" class="btn btn-primary" @click.stop="onGifteryModal">Связать с Giftery</button>
                            <!--<button v-if="reward.CanContactOzon" type="button" class="btn btn-primary" @click.stop="reward.OzonCertificate=true">Связать с Озон</button>-->
                        </div>
                        <div>Баланс: {{giftery.balance ? giftery.balance.toFixed(2) : 0 }}</div>
                    </div>
                    <div class="form-field" v-if="reward.RewardType === 1 || reward.RewardType === 2">
                        <label class="input-text-lbl">
                            Ссылка на сайт
                        </label>
                        <input name="WebLink" v-model="reward.WebLink" v-validate="'url'"
                               :class="['input-text', {'input-error': errors.has('WebLink')}]" type="text">
                        <span class="field-validation-valid">{{ errors.first('WebLink') }}</span>
                    </div>
                    <div class="form-field" v-if="domainFolders.length">
                        <label class="input-text-lbl">
                            Папка
                        </label>
                        <drop-down v-model="reward.DomainFolderId"
                                   :items="domainFolders"
                                   :dataField="'Id'"
                                   :textField="'Name'"></drop-down>
                        <span class="field-validation-valid">{{ errors.first('DomainFolderId') }}</span>
                    </div>
                    <div class="form-field" v-if="rewardGroups.length">
                        <label class="input-text-lbl">
                            Группа
                        </label>
                        <drop-down v-model="reward.GroupId"
                                   :items="rewardGroups"
                                   :dataField="'Id'"
                                   :textField="'Name'"></drop-down>
                        <span class="field-validation-valid">{{ errors.first('GroupId') }}</span>
                    </div>
                    <div class="form-field">
                        <label class="input-text-lbl">
                            Порядковый номер
                        </label>
                        <touch-spin v-model.number="reward.Order"></touch-spin>
                        <span class="field-validation-valid">{{ errors.first('Order') }}</span>
                    </div>
                    <div class="form-field">
                        <input id="Disabled" name="Disabled" value="true" type="checkbox" class="input-checkbox"
                               v-model="reward.Disabled" />
                        <label for="Disabled" class="input-checkbox-lbl">Отключить вознаграждение</label>
                    </div>
                    <div class="form-field margin-top-10" v-if="reward.RewardType !== 4">
                        <label class="input-text-lbl">
                            Номиналы
                        </label>
                        <template>
                            <table class="table-view margin-top-5">
                                <thead class="head-show">
                                    <tr style="text-align: center;">
                                        <th>{{ currencyEquivalentLabel }}</th>
                                        <th>Стоимость в баллах</th>
                                        <th>Можно выбрать</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tr v-for="(item, i) of reward.Prices">
                                    <td>
                                        <!--<touch-spin v-if="reward.OzonCertificate"
    v-model="item.Nominal" :name="'Nominal' + i"
    :decimals="0" :step="1" :min="100" :max="100000"
    placeholder="номинал (руб.)"
    v-validate="{ required: true }"
    :class="['input-text', {'input-error': errors.has('Nominal' + i)}]"></touch-spin>v-else -->
                                        <input type="text"
                                               :name="'Nominal' + i"
                                               placeholder="номинал (руб.)"
                                               :disabled="reward.GifteryId"
                                               v-model="item.Nominal"
                                               v-validate="{ regex: /^\d{1,}(\.|\,)?\d{0,}$/ }" :class="['input-text', {'input-error': errors.has('Nominal' + i) }]" />
                                    </td>
                                    <td>
                                        <input type="text"
                                               :name="'Price' + i"
                                               placeholder="баллы (за сколько баллов)"
                                               :disabled="reward.GifteryId"
                                               v-model="item.Price"
                                               v-validate="{ positive: true, required: true, regex: /^\d{1,}(\.|\,)?\d{0,}$/ }" :class="['input-text', {'input-error': errors.has('Price' + i) }]" />
                                    </td>
                                    <td class="value-center">
                                        <input value="true" type="checkbox"
                                               :id="'Active' + i"
                                               :name="'Active' + i"
                                               :class="['input-checkbox']"
                                               v-model="item.Active" />
                                        <label :for="'Active' + i" :class="['input-checkbox-lbl', {'error-lbl': item.Comment}]" :title="item.Comment">Вкл.</label>
                                    </td>
                                    <td class="bit">
                                        <button type="button" class="btn btn-default btn-img" @click="removePrice(item, i)" v-if="item.CanBeDeleted">
                                            <img src="../../../img/icon-del.png" alt="" />
                                        </button>
                                    </td>
                                </tr>
                            </table>
                            <button type="button" class="btn margin-top-10" v-if="reward.GifteryId" :disabled="giftery.loading" @click.stop="onGifteryUpdate">
                                <template v-if="giftery.loading">
                                    Идёт обновление, подождите...
                                </template>
                                <template v-else>
                                    Обновить из Giftery
                                </template>
                            </button>
                        </template>
                        <button type="button" class="btn btn-primary margin-top-5 btn-img" @click="addPrice()" v-if="!reward.GifteryId">
                            <img src="../../../img/icon-plus-2.png" alt="" />
                        </button>

                        <div class="form-field" v-if="allowManualNominal">
                            <input id="ManualNominal" name="ManualNominal" value="true" type="checkbox" class="input-checkbox"
                                   v-model="reward.ManualNominal" />
                            <label for="ManualNominal" class="input-checkbox-lbl">Ввести сумму</label>
                        </div>
                        <div class="form-field" v-if="reward.ManualNominal">
                            <label class="input-text-lbl">
                                Процент (от 0 до 100)
                            </label>
                            <input type="text"
                                   name="ManualNominalPercent"
                                   placeholder="Процент"
                                   v-model="reward.ManualNominalPercent"
                                   v-validate="{ percent: true, positive: true }" :class="['input-text', {'input-error': errors.has('ManualNominalPercent') }]" />
                        </div>
                        <div class="form-field-group mob-inline" v-if="reward.ManualNominal">
                          <div class="form-field">
                            <label class="input-text-lbl">
                                Минимальное значение
                            </label>
                            <input type="number"
                                   name="ManualNominalMin"
                                   placeholder="Минимальное значение"
                                   v-model="reward.ManualNominalMin"
                                   v-validate="{ numeric: true, positive: true }"
                                   :class="['input-text', {'input-error': errors.has('ManualNominalMin') }]" />
                          </div>
                          <div class="form-field">
                            <label class="input-text-lbl">
                                    Максимальное значение
                                </label>
                                <input type="number"
                                       name="ManualNominalMax"
                                       placeholder="Максимальное значение"
                                       v-model="reward.ManualNominalMax"
                                       v-validate="{ numeric: true, positive: true }"
                                       :class="['input-text', {'input-error': errors.has('ManualNominalMax') }]" />
                          </div>
                          <div class="form-field">
                            <label class="input-text-lbl">
                                Шаг к сумме
                            </label>
                            <input type="number"
                                   name="ManualNominalStep"
                                   placeholder="Шаг к сумме"
                                   v-model="reward.ManualNominalStep"
                                   v-validate="{ numeric: true, positive: true }"
                                   :class="['input-text', {'input-error': errors.has('ManualNominalStep') }]" />

                          </div>
                        </div>
                      </div>
                    <div v-else>
                        <label class="input-text-lbl">
                            Стоимость в баллах
                        </label>
                        <input type="text"
                               :name="'Price'"
                               placeholder="баллы"
                               v-model="reward.Prices[0].Price"
                               v-validate="{ positive: true, required: true, regex: /^\d{1,}(\.|\,)?\d{0,}$/ }" :class="['input-text', {'input-error': errors.has('Price') }]" />
                    </div>
                </div>

                <div class="block-in-page">
                    <div class="flex">
                        <image-setting :img="imgSite" :name="'site'" :parentImage="true" @onImageViewChanged="onImageViewChanged"></image-setting>
                        <div class="form-field" style="width:300px;min-width:300px;margin-left:20px">
                            <div class="panel-block panel-block-new" style="margin-right:0">
                                <div class="panel-block-img-base">
                                    <div class="panel-block-img">
                                        <img :src="imgSitePath" alt="" :style="imageStyleFormatted" v-if="imgSitePath" />
                                    </div>
                                </div>
                                <div class="panel-block-info">
                                    <p class="panel-block-header margin-bottom-10">{{ reward.Name }}</p>
                                </div>
                                <div class="panel-body-actions">
                                    <button class="btn" type="button">Выбрать</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="block-in-page">
                    <div class="flex">
                        <image-setting :img="imgMobile" :parentImgPath="imgSitePath" :name="'mobile'" @onImageViewChanged="onImageViewChanged"></image-setting>
                        <div class="form-field" style="width:500px;min-width:500px;margin-left:20px">
                            <div class="panel-block panel-block-new panel-block-mobile" style="margin-right:0">
                                <div class="flex">
                                    <div class="panel-block-img panel-block-img-mobile">
                                        <img :src="imgMobilePath" alt="" :style="imageStyleMobileFormatted" v-if="imgMobilePath" />
                                    </div>
                                    <div class="panel-block-info">
                                        <div>
                                            <p class="panel-block-header margin-bottom-10">{{ reward.Name }}</p>
                                            <p class="panel-block-header margin-bottom-10">{{ reward.Description }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="panel-body-actions">
                                    <button class="btn" type="button">Выбрать</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </template>

        <popup-window ref="ppGiftery" :title="'Сертификаты Giftery'" :width="'80%'">
            <p class="p-header-1"></p>
            <div>
                <span v-if="giftery.loading">Идёт загрузка...</span>

                <div v-if="giftery.data && giftery.data.length && !giftery.loading" class="products">
                    <div v-for="item of giftery.data">
                        <div class="product-item" @click.stop="onGifterySelect(item)">
                            <p class="p-header-1">{{item.title}}</p>
                            <img :src="item.main_image.small" :alt="item.title" :title="item.brief"/>
                        </div>
                    </div>
                </div>
            </div>
        </popup-window>

        <vue-headful title="Вознаграждения" />
    </div>
</template>

<script>
    import BackendApi from '../../backendApi'
    import $ from 'jquery'
    import UI from '../../helpers/ui-helpers'
    import projectMixin from '../../helpers/project-mixin'
    import {RewardTypes} from '../../enums'

    let backendApi = new BackendApi();


    let ImageStyleDefault = {
        top: 0,
        left: 100,
        translateY: 0,
        translateX: -50,
        size: 100,
        resizeType: 1
    };

    export default {
        name: "reward-edit",

        mixins: [projectMixin],

        data() {
            return {
                reward: null,
                file: null,
                deleteImage: false,
                types: [
                    {Id: RewardTypes.ElectronicGiftCard, Name: 'Электронная подарочная карта'},
                    {Id: RewardTypes.PrepaidBankCard, Name: 'Предоплаченная банковская карта'},
                    {Id: RewardTypes.PhysicalBankCard, Name: 'Пополнение личной карты'},
                    {Id: RewardTypes.PhysicalPrize, Name: 'Физический приз'}
                ],
                domainFolders: [{
                    Id: '',
                    Name: 'Выбрать'
                }],
                rewardGroups: [{
                    Id: '',
                    Name: 'Без категории'
                }],
                giftery:{
                    data: [],
                    loading: false,
                    balance: null
                },
                imgSitePath: null,
                imgSite: {},
                imgMobilePath: null,
                imgMobile: {},
                savingInProgress: false,
                project: null
            }
        },

        computed:{
            currencyEquivalentLabel() {
              if (!this.project || !this.project.CountryId) {
                return 'Эквивалент в деньгах'; // значение по умолчанию, если project или CountryId не определены
              }
              switch (this.project.CountryId) {
                case 1: // Россия
                  return 'Эквивалент в рублях';
                case 2: // Беларусь
                  return 'Эквивалент в белорусских рублях';
                case 3: // Казахстан
                  return 'Эквивалент в тенге';
                default:
                  return 'Эквивалент в деньгах';
              }
            },

            imageStyleFormatted() {
                let settings = {
                    left: this.imgSite.ImageStyle.left + '%',
                    top: this.imgSite.ImageStyle.top + '%',
                    transform: 'translateY(' + this.imgSite.ImageStyle.translateY + '%) translateX(' +
                        this.imgSite.ImageStyle.translateX + '%)'
                };
                if (this.imgSite.ImageStyle.resizeType === 1 && parseInt(this.imgSite.ImageStyle.size)) {
                    settings.height = this.imgSite.ImageStyle.size + '%';
                }
                if (this.imgSite.ImageStyle.resizeType === 2 && parseInt(this.imgSite.ImageStyle.size)) {
                    settings.width = this.imgSite.ImageStyle.size + '%';
                }

                return settings;
            },

            imageStyleMobileFormatted() {
                let settings = {
                    left: this.imgMobile.ImageStyle.left + '%',
                    top: this.imgMobile.ImageStyle.top + '%',
                    transform: 'translateY(' + this.imgMobile.ImageStyle.translateY + '%) translateX(' +
                        this.imgMobile.ImageStyle.translateX + '%)'
                };
                if (this.imgMobile.ImageStyle.resizeType === 1 && parseInt(this.imgMobile.ImageStyle.size)) {
                    settings.height = this.imgMobile.ImageStyle.size + '%';
                }
                if (this.imgMobile.ImageStyle.resizeType === 2 && parseInt(this.imgMobile.ImageStyle.size)) {
                    settings.width = this.imgMobile.ImageStyle.size + '%';
                }

                return settings;
            },

            allowManualNominal() {
                //this.reward.RewardType === RewardTypes.ElectronicGiftCard && this.reward.OzonCertificate;
                return this.reward.RewardType !== RewardTypes.PhysicalPrize;
            }
        },

        methods: {
            onGifteryUpdate(){
                let vm = this;

                vm.loadGidteryProducts().then(() => {
                    if(!vm.giftery.data.length){
                        return;
                    }

                    let item = vm.giftery.data.find(x => x.id == vm.reward.GifteryId);
                    if(!item){
                        UI.toastr.error('Ошибка обновления, обратитесь к администратору');
                        return;
                    }

                    for(let oldRewardPrice of vm.reward.Prices){
                        if(!item.faces.find(x => x === oldRewardPrice.Price) && !oldRewardPrice.Active){
                            oldRewardPrice.Active = false;
                            oldRewardPrice.Comment = 'Номинал недоступен';
                        }
                    }
                    for(let face of item.faces){
                        if(face === 0){
                            continue;
                        }
                        let rewardPrice = vm.reward.Prices.find(x => x.Price === face);
                        if(!rewardPrice){
                            vm.reward.Prices.push({
                                Nominal: face,
                                Price: face,
                                Active: true
                            });
                        }
                    }

                    UI.toastr.success('Успешно обновлено');
                });
            },

            onRewardTypeChenge(item){
                if(item.Id === RewardTypes.PhysicalPrize){
                    if(!this.reward.Prices.length){
                        this.reward.Prices.push({
                            Price: 0,
                            Nominal: '',
                            Active: true,
                            CanBeDeleted: true
                        })
                    }else if (this.reward.Prices.length > 1){
                        this.reward.Prices.splice(1, this.reward.Prices.length - 1);
                    }
                }
            },

            onGifterySelect(item){
                let vm = this;

                vm.reward.GifteryId = item.id;
                vm.reward.Name = item.title;
                // todo: html
                vm.reward.Description = item.brief.replace('<p>', '').replace('</p>', '');

                for(let oldRewardPrice of vm.reward.Prices){
                    if(!item.faces.find(x => x === oldRewardPrice.Price) && !oldRewardPrice.Active){
                        oldRewardPrice.Active = false;
                        oldRewardPrice.Comment = 'Номинал недоступен';
                    }
                }
                for(let face of item.faces){
                    if(face === 0){
                        continue;
                    }
                    let rewardPrice = vm.reward.Prices.find(x => x.Price === face);
                    if(!rewardPrice){
                        vm.reward.Prices.push({
                            Nominal: face,
                            Price: face,
                            Active: true
                        });
                    }
                }

                vm.$refs['ppGiftery'].close();
            },

            onGifteryModal(){
                let vm = this;

                vm.$refs['ppGiftery'].show();
                vm.loadGidteryProducts();
            },

            loadGidteryProducts(){
                let vm = this;

                vm.giftery.loading = true;
                vm.giftery.data = [];

                return backendApi.gifteryProducts().then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке продуктов Giftery');
                    }
                    else {
                        console.info('loadGidteryProducts -> response:', JSON.parse(JSON.stringify(response.data)));
                        vm.giftery.data = response.data;
                    }
                    vm.giftery.loading = false;
                });
            },

            back() {
                this.$router.back();
            },

            addPrice(){
                let vm = this;

                vm.reward.Prices.push({
                    Price: 0,
                    Nominal: '',
                    Active: true,
                    CanBeDeleted: true
                });
            },

            removePrice(item, index) {
                this.reward.Prices.splice(index, 1);
            },

            loadEntity() {
                let that = this;
                let id = parseInt(this.$route.params.id);
                if (id === 0) {
                    this.reward = {
                        new: true,
                        ImageStyle: JSON.parse(JSON.stringify(ImageStyleDefault)),
                        FileData: null,
                        Prices: [],
                        Name : null,
                        Description : null,
                        WebLink: null,
                        GifteryId: null,
                        ManualNominal: false,
                        ManualNominalPercent: 0,
                        ManualNominalMin: 0,
                        ManualNominalMax: 0,
                        ManualNominalStep: 0,
                        ImageStyleMobile: JSON.parse(JSON.stringify(ImageStyleDefault)),
                        ImageMobile: {},
                        OzonCertificate: false
                    };
                    that.imgSite = {
                        ImageStyle: that.reward.ImageStyle,
                        ImagePath: null,
                        Image: {}
                    };
                    that.imgMobile = {
                        ImageStyle: that.reward.ImageStyleMobile,
                        ImagePath: null,
                        Image: {}
                    };

                    return new Promise(resolve => resolve());
                }
                else {
                    return backendApi.rewardsLoad(id).then(function (response) {
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при загрузке вознаграждения');
                        }
                        else {
                            if (response.data == null) {
                                that.$router.back();
                            }

                            if (response.data.ImageStyle) {
                                response.data.ImageStyle = JSON.parse(response.data.ImageStyle);
                            } else {
                                response.data.ImageStyle = JSON.parse(JSON.stringify(ImageStyleDefault));
                            }
                            if (response.data.ImageStyleMobile) {
                                response.data.ImageStyleMobile = JSON.parse(response.data.ImageStyleMobile);
                            } else {
                                response.data.ImageStyleMobile = JSON.parse(JSON.stringify(ImageStyleDefault));
                            }
                            response.data.FileData = null;
                            response.data.GroupId = response.data.Group ? response.data.Group.Id : null;
                            response.data.ManualNominal = response.data.ManualNominalPercent !== null;

                            that.reward = response.data;
                            that.reward.ImageMobile = {};
                            that.imgMobile = {
                                ImageStyle: that.reward.ImageStyleMobile,
                                ImagePath: that.reward.ImageMobilePath,
                                Image: {}
                            };
                            that.imgSite = {
                                ImageStyle: that.reward.ImageStyle,
                                ImagePath: that.reward.Image,
                                Image: {}
                            };
                        }
                    })
                }
            },

            saveEntity() {
                let vm = this;

                this.$validator.validate().then(result => {
                    if (!result) {
                        UI.toastr.error('Проверьте введённые данные');
                    }
                    else {
                        if (vm.savingInProgress) {
                            return;
                        }
                        vm.savingInProgress = true;
                        UI.blockUI('.dataContent', 'Сохранение...');

                        let saveObj = Object.assign({}, vm.reward, {
                            DeleteImage: vm.imgSite.Image.Id === -1,
                            ProjectId: vm.projectId,
                        });
                        saveObj.ImageStyle = JSON.stringify(saveObj.ImageStyle);
                        if(!vm.reward.ManualNominal){
                            saveObj.ManualNominalPercent = null;
                        }
                        saveObj.ImageStyle = JSON.stringify(vm.imgSite.ImageStyle);
                        saveObj.FileData = vm.imgSite.Image.FileData;
                        saveObj.FileName = vm.imgSite.Image.FileName;
                        saveObj.ImageMobile = vm.imgMobile.Image;
                        if (vm.imgMobile.ImageStyle.useMainPhoto) {
                            saveObj.ImageMobile.FileName = '';
                            saveObj.ImageMobile.FileData = '';
                            saveObj.ImageMobile.Id = -1;
                            saveObj.ImageMobilePath = '';
                        }
                        saveObj.ImageStyleMobile = JSON.stringify(vm.imgMobile.ImageStyle);

                        // if(saveObj.Prices.length === 1){
                        //     saveObj.Prices[0].Nominal = '';
                        //     saveObj.Prices[0].Active = true;
                        // }
                        //console.info('saveObj', saveObj)

                        backendApi.rewardsSave(saveObj).then(function (response) {
                            UI.unblockUI('.dataContent');
                            if (response.hasError) {
                                UI.toastr.error('Ошибка при сохранении вознаграждения');
                            } else {
                                UI.toastr.success('Успешно сохранено');
                                vm.$router.back();
                            }
                            vm.savingInProgress = false;
                        });
                    }
                });
            },

            deleteEntity(){
                let that = this;

                if (confirm('Вы уверены?')) {
                    UI.blockUI('.portlet', 'Удаление...');
                    backendApi.rewardsDelete(that.reward.Id).then(function (response) {
                        UI.unblockUI('.portlet');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при удалении вознаграждения');
                        } else {
                            UI.toastr.success('Успешно удалено');
                            that.$router.push('/spend-bonuses');
                        }
                    });
                }
            },

            loadGroups(){
                let vm = this;
                return backendApi.rewardGroupList(vm.projectId).then(function (response) {
                    vm.rewardGroups.push(...response.data);
                });
            },

            loadProject(){
              let vm = this;

              return this.callApiWrapper(backendApi.projectLoad(vm.projectId)).then(function (resp) {
                if (resp.data) {
                  vm.project = resp.data;
                }
              });
            },

            loadFolders(){
                let vm = this;
                return backendApi.domainFoldersList(vm.projectId, 2).then(function (response) {
                    vm.domainFolders.push(...response.data);
                });
            },

            loadGifteryBalance(){
                let vm = this;
                return backendApi.getGifteryBalance(vm.projectId).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при получении баланса Giftery');
                    } else {
                        if (response.data.HasError) {
                            UI.toastr.error('Ошибка при получении баланса Giftery: ' + response.data.Error);
                        } else {
                            vm.giftery.balance = response.data.Data.balance// ? response.data.Data.balance : 0;
                        }
                    }
                });
            },

            onImageViewChanged(imgPath, name) {
                if (name === 'site')
                    this.imgSitePath = imgPath;
                else
                    this.imgMobilePath = imgPath;
            }
        },


        mounted() {
            let vm = this;

            UI.blockUI('.page-content', 'Загрузка...');
            Promise.all([this.loadFolders(), this.loadGroups(), this.loadProject()]).then(() => {
                vm.loadEntity().then(() => {
                    UI.unblockUI('.page-content');

                });
                vm.loadGifteryBalance();
            });

        },

        destroyed(){
            
        }
    }
</script>

<style scoped>
    .products{
        display: flex;
        flex-wrap: wrap;
    }
    .products > div{
        width: 25%;
    }
    .products .product-item{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 0 20px 20px;
        cursor: pointer;
    }
    .products .product-item img {
        width: 100%;
    }
    .input-checkbox-lbl.error-lbl:before{
        border-color: red;
    }

    .input-checkbox-lbl.error-lbl:before{
        border-color: red;
    }

    .input-checkbox-lbl.error-lbl:before{
        border-color: red;
    }

    @media (min-width: 1px) and (max-width: 768px) {
        .products > div{
            width: 50%;
        }
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/edit/RewardEdit.vue